export default __webpack_public_path__ + "static/media/gallery_04.a9e4b4a7.jpg";